import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  fieldset: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  legend: {
    fontSize: 18,
    fontWeight: 500,
    color: theme.palette.secondary.main,
    padding: `0 ${theme.spacing(1)}px`,
  },
}));

export interface Props {
  legend: string;
}

export const FieldSet: React.FC<Props> = ({ children, legend }) => {
  const { fieldset, legend: legendClass } = useStyles();

  return (
    <fieldset className={fieldset}>
      <legend className={legendClass}>
        {legend}
      </legend>
      {children}
    </fieldset>
  );
};
